import { ReactElement, useMemo } from 'react'
import { Vector3 } from 'three'
import { useAppStore } from '@stores'
import Arrow from 'src/components/scene/Arrow'
import { getContrastTextColor } from 'src/utils/color'
import {
  formatHorizontalWindLoadForceLabel,
  HORIZONTAL_WIND_LOAD_COLOR,
  HorizontalWindLoadArrow,
} from './utils'

interface Props {
  loads: HorizontalWindLoadArrow[]
  activeWindAngle: WindAngle
}

const ManualWindLoadsSceneMarkers = ({ loads }: Props): ReactElement => {
  const loadTextScale = useAppStore(state => state.loadRenderConfig.lineLoads.textScale)
  const textColor = useMemo(() => getContrastTextColor(HORIZONTAL_WIND_LOAD_COLOR), [])

  return (
    <>
      {loads.map(load => {
        const labelPosition = load.origin
        const textXDirection = new Vector3(1, 0, 0)
        const textYDirection = new Vector3(0, 1, 0)

        return (
          <Arrow
            key={load.id}
            direction={load.direction}
            origin={load.origin}
            length={load.length}
            backgroundColor={HORIZONTAL_WIND_LOAD_COLOR}
            color={textColor}
            label={formatHorizontalWindLoadForceLabel(load.force)}
            labelPosition={labelPosition}
            labelAnchorLocation={'center'}
            labelScale={loadTextScale}
            lineWidth={0.05}
            headWidth={0.15}
            renderOnTop
            textXDirection={textXDirection}
            textYDirection={textYDirection}
          />
        )
      })}
    </>
  )
}

export default ManualWindLoadsSceneMarkers
